/* eslint-disable react/jsx-props-no-spreading */
/**
 * @description Simple loading spinner for an iframe
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import Box from '@mui/material/Box';

import Spinner from '@seccon/shared/ui/components/Spinner';

const styles = {
  loading: {
    visibility: 'hidden'
  },
  loadingContainer: {
    display: 'flex',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
}

const IFrame = ({ sx, title, ...props }) => {
  const [loading, setLoading] = React.useState(true);

  return (
    <>
      {loading && (
        <Box sx={styles.loadingContainer}>
          <Spinner width='4rem' height='4rem' />
        </Box>
      )}
      <iframe
        style={loading ? styles.loading : null}
        title={title}
        onLoad={() => setLoading(false)}
        {...props}
      />
    </>
  )
};

IFrame.propTypes = {
  sx: PropTypes.object,
  title: PropTypes.string.isRequired
};

IFrame.defaultProps = {
  sx: null
};

export default IFrame;
